"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _classnames = _interopRequireDefault(require("classnames"));

var _link = require("@insided/deprecated-preact-components/menu/link");

var _list = _interopRequireDefault(require("@insided/deprecated-preact-components/menu/list"));

var _CategoryList = require("./CategoryList");

var _Types = require("./Types");

var NestedCategoryList = function NestedCategoryList(_ref) {
  var category = _ref.category,
      _getItemProps = _ref.getItemProps,
      isHamburgerList = _ref.isHamburgerList,
      topOffset = _ref.topOffset;
  return (0, _preact.h)("li", {
    className: (0, _classnames.default)('dropdown', 'dropdown--forums-overview', 'main-menu-list--overflow-scroll'),
    id: "mega-menu-category-dropdown-".concat(category.id),
    style: topOffset ? {
      top: "".concat(topOffset, "px")
    } : undefined
  }, (0, _preact.h)(_list.default, {
    getItemProps: function getItemProps(idx) {
      return _getItemProps({
        item: idx,
        className: 'main-menu-list__item'
      });
    }
  }, category.children.map(function (child) {
    var id = child.id,
        title = child.title,
        url = child.url,
        visibleTopicsCount = child.visibleTopicsCount; // Check if this child has external property (MegaMenuCategory or WidgetSetting)

    var external = (0, _Types.hasExternalProperty)(child) ? child.external : undefined;
    return (0, _preact.h)(_link.CategoryLink, {
      key: id,
      track: (0, _CategoryList.trackCategory)(title, url, false),
      gaEvents: (0, _CategoryList.gaEvents)(url),
      href: (0, _absoluteUrlRuntime.resolveUrl)(url),
      title: title,
      topicsCount: visibleTopicsCount,
      isHamburger: isHamburgerList,
      external: external
    }, title);
  })));
};

var _default = NestedCategoryList;
exports.default = _default;